import {
  Component,
  Inject,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { AlertData } from '../../../common/models/common/alert/alert-data';
import { CommonUrlBasedService } from '../../../services/common.url-based.service';
import {
  faCircleQuestion,
  faTriangleExclamation,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mec-alert',
  imports: [CommonModule, MatDialogModule, FontAwesomeModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements AfterViewInit, OnDestroy {
  @ViewChild('contentContainer', { static: false })
  public contentContainer: ElementRef<HTMLDivElement>;

  public confirmIcon = faCircleQuestion;
  public errorIcon = faTriangleExclamation;
  public helpIcon = faCircleInfo;

  private _contentClickListener: EventListenerOrEventListenerObject;

  constructor(
    public _commonService: CommonUrlBasedService,
    public _dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertData
  ) {}

  public ngAfterViewInit(): void {
    if (!this.contentContainer?.nativeElement || !this.data?.onAction) {
      return;
    }

    this._contentClickListener = (event: Event): void => {
      const target = event.target as HTMLElement;
      const anchor = target.closest(
        'a[data-policy-index]'
      ) as HTMLAnchorElement;

      if (!anchor) {
        return;
      }

      event.preventDefault();
      const index = anchor.dataset['policyIndex'];
      this.data.onAction?.(index);
    };

    this.contentContainer.nativeElement.addEventListener(
      'click',
      this._contentClickListener
    );
  }

  public ngOnDestroy(): void {
    if (this.contentContainer?.nativeElement && this._contentClickListener) {
      this.contentContainer.nativeElement.removeEventListener(
        'click',
        this._contentClickListener
      );
    }
  }
}
